export default __webpack_public_path__ + "static/media/insumos.cd658755.svg";